import '../css/App.css';
import Webpage from './Webpage';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SignIn from './SignIn';
import React, { useState, useEffect } from 'react';
import PulseLoader from 'react-spinners/PulseLoader'; // Import PulseLoader for the custom loader
import Chatbot from './Chatbot';

function App() {
  const queryParams = new URLSearchParams(window.location.search);
  const host = queryParams.get('host') || 'ktpl.kpoint.com';
  const id = queryParams.get('id');
  const k = queryParams.get('k') || '4';
  const hostUrl = queryParams.get('url') || 'https://ktpl.kpoint.com/assets/orca/media/embed/player-silk.js';

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);  // Loading state


  // // Check if the user is already signed in on page load
  // useEffect(() => {
  //   const storedAccessToken = localStorage.getItem('accessToken');
  //   if (storedAccessToken) {
  //     setIsSignedIn(true);
  //     console.log("already sign in")
  //   }
  //   setIsLoading(false);  // Once the check is done, stop loading
  // }, []);

  // Handle successful sign-in and store user details
  // const handleSignIn = (tokens) => {

  //   // Store the access token and profile in local storage for persistence
  //   localStorage.setItem('accessToken', tokens.access_token);
  //   localStorage.setItem('userProfile', JSON.stringify(tokens.profile)); // Store the profile as a string
  //   setIsSignedIn(true);
  // };

  // if (isLoading) {
  //   return (
  //     <div className="loader-container">
  //       <PulseLoader size={8} color="#30c484" />
  //     </div>
  //   );
  // }


  return (
    <div className="App">
      <main>
        <Webpage  
              id={id} 
              host={host}
              hostUrl={hostUrl}
              k={k}
            />
        {/* <GoogleOAuthProvider clientId='898015710493-a8gpr84qjvbvbd0ru1gmvo69m3b78j8l.apps.googleusercontent.com'>
          {!isSignedIn ? (
            <SignIn onSignIn={handleSignIn} />
          ) : (
            
            
          )}
        </GoogleOAuthProvider> */}
      </main>
    </div>
  );
}

export default App;
